import styled from '@emotion/styled';
import ButtonComponent from 'components/Button/Button';

export const DataButton = styled(ButtonComponent)`
  width: 12rem;
`;
